import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { Globals } from "./globals";

@Injectable()
export class CustomMenuIconService {

  assetsUrl = '';

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    public globals: Globals,
  ) {
    this.assetsUrl = this.globals.getAssetsUrl();
  }

  init() {
    console.log( " assetUrl - " , this.assetsUrl );
    this.matIconRegistry.addSvgIcon(
      "dashboard",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        this.assetsUrl +"assets/images/menu-icon/dashboard.svg"
      )
    );
    this.matIconRegistry.addSvgIcon(
      "live-feed",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        this.assetsUrl +"assets/images/menu-icon/live-feed.svg"
      )
    );
    this.matIconRegistry.addSvgIcon(
      "analytics",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        this.assetsUrl +"assets/images/menu-icon/analytics.svg"
      )
    );
    this.matIconRegistry.addSvgIcon(
      "suppression-list",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        this.assetsUrl +"assets/images/menu-icon/suppression-list.svg"
      )
    );
    this.matIconRegistry.addSvgIcon(
      "marketing",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        this.assetsUrl +"assets/images/menu-icon/marketing.svg"
      )
    );
    this.matIconRegistry.addSvgIcon(
      "user-management",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        this.assetsUrl +"assets/images/menu-icon/user-management.svg"
      )
    );
    this.matIconRegistry.addSvgIcon(
      "Logs",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        this.assetsUrl +"assets/images/menu-icon/Logs.svg"
      )
    );
    this.matIconRegistry.addSvgIcon(
      "billing",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        this.assetsUrl +"assets/images/menu-icon/billing.svg"
      )
    );
    this.matIconRegistry.addSvgIcon(
      "setting",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        this.assetsUrl +"assets/images/menu-icon/setting.svg"
      )
    );
    this.matIconRegistry.addSvgIcon(
      "help",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        this.assetsUrl +"assets/images/menu-icon/help.svg"
      )
    );
    this.matIconRegistry.addSvgIcon(
      "insight",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        this.assetsUrl +"assets/images/menu-icon/insight.svg"
      )
    );
    this.matIconRegistry.addSvgIcon(
      "whatsapp",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        this.assetsUrl +"assets/images/menu-icon/whatsapp.svg"
      )
    );
    this.matIconRegistry.addSvgIcon(
      "opt-in",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        this.assetsUrl +"assets/images/menu-icon/opt-in.svg"
      )
    );
    this.matIconRegistry.addSvgIcon(
      "template",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        this.assetsUrl +"assets/images/menu-icon/template.svg"
        )
      );
    this.matIconRegistry.addSvgIcon(
      "rcs",
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        this.assetsUrl +"assets/images/menu-icon/Google_RCS.svg"
      )
    );
  }

}
